<template>
  <!-- input 单行文本框：maxlength + 前后缀标签 -->
  <a-row :gutter="16">
    <TextAddonConfig :config="config" />
  </a-row>
</template>

<script setup lang="ts">
import TextAddonConfig from '../TextAddonConfig.vue';

defineProps<{ config: any }>();
</script>
